module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-id-card-o',\n    title: 'Personal info',\n    description: 'Let Clerk get to know you and your business.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/1-owner/owner.section-header.html
// module id = 4072
// module chunks = 86